import Vue from 'vue'
import XRHead  from './head'

export default XRHead




// WEBPACK FOOTER //
// ./src/components/usercenter/head/index.js